import React from 'react';
import { Input, Label } from 'reactstrap';

class Counties extends React.Component {

    getCounties = () => {
        const options = [<option key={0} value={''} disabled>Select a County</option>];

        this.props.counties && this.props.counties.forEach((county, index) => {
            options.push(<option key={index+1} value={county.countyId}>{county.name}</option>);
        });

        return options;
    }

    handleOnChange = (e) => this.props.onChange(e.target.value);

    render() {
        return (
            <React.Fragment>
                <Label>County:</Label>
                <Input name='county' type='select' id='selectCounty' onChange={this.handleOnChange} value={this.props.value || ''}>
                    {this.getCounties()}
                </Input>
            </React.Fragment>
        );
    }
}

export default Counties;